import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';
import Typography from '@mui/material/Typography'; // Import Typography for text styling

interface LoaderProps {
  message?: string; // Optional message prop
}

const Loader: React.FC<LoaderProps> = ({ message }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column', // Stack items vertically
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%', // Cover only the height of the parent component
        width: '100%', // Cover only the width of the parent component
        position: 'absolute', // Position relative to the nearest positioned ancestor
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent background
        zIndex: 9999, // Ensure it covers other content
      }}
    >
      <CircularProgress />
      {message && (
        <Typography
          sx={{
            marginTop: 2, // Space between the loader and the message
            color: 'white', // Text color for visibility
            textAlign: 'center', // Center align text
            fontSize: '1.2rem', // Font size
          }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default Loader;
